import api from '@/services/Api';
import { AxiosResponse } from 'axios';
import { ActionContext, Module } from 'vuex';
import Systemdaten from '@/types/Systemdaten';
import { successSwal } from '@/helper/swals';
import { RootState, SystemdatenState } from '@/store/types';

type Context = ActionContext<SystemdatenState, RootState>;

export const systemdaten: Module<SystemdatenState, RootState> = {
    namespaced: true,
    state: {
        systemdaten: new Systemdaten(),
        dialog: {
            detail: false,
        },
        loaders: {
            systemdaten: false,
            save: false,
        },
    },
    actions: {
        loadSystemdaten({ commit }: Context): void {
            commit('setSystemdatenLoaders', { systemdaten: true });

            api.post('verwaltung/systemdaten/load')
                .then((response: AxiosResponse) => commit('setSystemdaten', response.data.body))
                .catch(console.error)
                .finally(() => commit('setSystemdatenLoaders', { systemdaten: false }));
        },
        updateSystemdaten({ commit }: Context, payload: Systemdaten): void {
            commit('setSystemdatenLoaders', { save: true });

            api.post('verwaltung/systemdaten/save', payload)
                .then(() => successSwal('Systemdaten', 'gespeichert'))
                .catch(console.error)
                .finally(() => {
                    commit('setSystemdatenDialogDetail', false);
                    commit('setSystemdatenLoaders', { save: false });
                });
        },
        setSystemdatenDialogDetail({ commit }: Context, payload: boolean): void {
            commit('setSystemdatenDialogDetail', payload);
        },
    },
    mutations: {
        setSystemdatenDialogDetail(state: SystemdatenState, visible: boolean): void {
            state.dialog.detail = visible;

            if (visible) {
                state.systemdaten = new Systemdaten();
            }
        },
        setSystemdaten(state: SystemdatenState, systemdaten: Systemdaten): void {
            state.systemdaten = new Systemdaten(systemdaten);
        },
        setSystemdatenLoaders(state: SystemdatenState, newState: { systemdaten?: boolean; save?: boolean }): void {
            state.loaders = {
                ...state.loaders,
                ...newState,
            };
        },
    },
};
